export function cleanupTaggedTemplateString(taggedTemplateString) {
    return taggedTemplateString.replace(/[\r\n]+/gm, '');
}
export function isEmptyOrWhiteSpace(stringToCheck) {
    if (!stringToCheck) {
        return true;
    }
    return stringToCheck.trim() === '';
}
export function removeRepeatingCharacters(stringToCleanup, charWhichShouldNotRepeated) {
    return stringToCleanup.replace(new RegExp(charWhichShouldNotRepeated + "+", 'g'), charWhichShouldNotRepeated);
}
export function countOccurrences(theString, searchString) {
    return (theString.match(new RegExp(searchString, 'g')) || []).length;
}
export function removeTrailingString(theString, trailingString) {
    return theString.replace(new RegExp(trailingString + "$"), '');
}
//#region validation
export function isHexString(theString) {
    return /^[a-fA-F0-9]+$/.test(theString);
}
//#endregion
//# sourceMappingURL=StringHelpers.js.map